import { useQuery } from '@tanstack/react-query'
import { supabase } from '@/lib/supabase'

export interface AppConfig {
    minimum_required_version: string;
    current_legal_version: string;
    terms_effective_date: string | null;
    privacy_effective_date: string | null;
    eula_effective_date: string | null;
}

export function useAppConfig() {
    return useQuery({
        queryKey: ['appConfig'],
        queryFn: async () => {
            const { data, error } = await supabase
                .from('app_config')
                .select('*')
                .single()
                
            if (error) throw error
            return data as AppConfig
        },
        staleTime: 1000 * 60 * 5, // 5 minutes
    })
}
